import {useEffect, useState} from 'react'
export const useSearchHistory = (key: string) => {
    const STORAGE_KEY = `search_history_${key}`
    const MAX_ITEMS = 20

    const [history, setHistory] = useState<string[]>(() => {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
        } catch {
            return []
        }
    })

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(history))
    }, [history])

    const sync = () => {
        try {
            const latest = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
            setHistory(latest)
        } catch {
            setHistory([])
        }
    }

    const add = (value: string) => {
        const trimmed = value.trim()
        if (!trimmed) return

        setHistory(prev => {
            const filtered = prev.filter(i => i !== trimmed)
            return [trimmed, ...filtered].slice(0, MAX_ITEMS)
        })
    }


    return { history, add, sync }
}